import {ErrorBoundary} from 'react-error-boundary'

import {ErrorFallback} from '@/client/core/components/error-fallback'

import {UnauthCheck} from './unauth-check'

/**
 * App for the anonymous users only, without any layout markups
 */
function UnauthenticatedApp({children}: {children: React.ReactNode}) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => window.location.assign(window.location.origin)}
      onError={(error: Error, info: {componentStack: string}) => {
        // LATER: report
      }}
    >
      <UnauthCheck>{children}</UnauthCheck>
    </ErrorBoundary>
  )
}

export {UnauthenticatedApp}
